<div class="container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Allocate Pools</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>
    <div
      class="col-12 col-sm-12 col-md-12 col-lg-12 allocate-reject-all-header d-flex flex-wrap align-items-center"
    >
      <span class="links-span">
        <a
          class="allocate-pools-links"
          (click)="handleAllocateAll()"
          [attr.disabled]="isAllocateAllDisabled ? true : null"
          [ngClass]="{ disabled: isAllocateAllDisabled }"
        >
          Allocate All
        </a>
        <a
          class="allocate-pools-links reject-all-link"
          (click)="handleRejectAll()"
          [attr.disabled]="isRejectAllDisabled ? true : null"
          [ngClass]="{ disabled: isRejectAllDisabled }"
        >
          Reject All</a
        >
        <a
          class="allocate-pools-links reject-all-link"
          [hidden]="displayResetLink"
          (click)="handleResetSelection()"
        >
          Reset</a
        >
      </span>
      <div class="ms-auto">
        <ul class="list-inline allocate-pool-labels-list">
          <li class="total-megas fw-bold">
            Valid Pools: {{ countForTotalMegas }}<span class="fw-bold">/</span
            >{{ totalCountFromValidatePools }}
            <span class="pr-10" *ngIf="totalMegaErrorsCount > 1">
              <i
                class="fa fa-info-circle tooltip-error icon-for-valid-megas"
                data-bs-toggle="tooltip"
                data-bs-html="true"
                title="{{
                  totalMegaErrorsCount
                }} pools have errors and cannot be allocated. For more details, a full error report
                      will be available at the end of the process."
              >
              </i
            ></span>
            <span class="pr-10" *ngIf="totalMegaErrorsCount === 1">
              <i
                class="fa fa-info-circle tooltip-error icon-for-valid-megas"
                data-bs-toggle="tooltip"
                data-bs-html="true"
                title="{{
                  totalMegaErrorsCount
                }} pool has errors and cannot be allocated. For more details, a full error report
                      will be available at the end of the process."
              >
              </i
            ></span>
            <span class="show-pipe-symbol">|</span>
          </li>
          <li class="allocate-text">
            Allocate: {{ countForAllocatedMegas }} <span class="show-pipe-symbol">|</span>
          </li>
          <li class="reject-text">Reject: {{ countForRejectMegas }}</li>
          <span class="confirm-button">
            <button
              class="button fm-primary-button"
              id="confirm-button"
              type="button"
              (click)="navigateToConfirmationPage()"
              [disabled]="isConfirmButtonDisabled"
            >
              Confirm
            </button>
          </span>
        </ul>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <form>
        <div class="fm-cdx-table">
          <table class="fm-cdx-table__static">
            <tbody>
              <tr
                class="td_row commit-mega-table-header"
                *ngFor="
                  let validatedMega of validatedMegaList;
                  let idx = index;
                  trackBy: trackByIdentity
                "
              >
                <td class="td_cell allocate-reject-radio-button-column">
                  <div
                    class="allocate-radio-div allocate-reject-button"
                    (click)="allocationStatus(idx)"
                    #allocateLabel
                  >
                    <i
                      class="fa fa-circle-o"
                      aria-hidden="true"
                      *ngIf="validatedMega?.status !== 'allocate'"
                    ></i>
                    <i
                      class="fa fa-dot-circle-o"
                      aria-hidden="true"
                      *ngIf="validatedMega?.status === 'allocate'"
                    ></i>
                    <input
                      type="checkbox"
                      class="d-none allocate-check"
                      name="allocate"
                      [value]="validatedMega?.status === 'allocate'"
                      required
                      #allocateRadio
                    />

                    <label class="radio-buttons-labels">Allocate</label>
                  </div>
                  <div
                    class="reject-radio-div allocate-reject-button"
                    (click)="rejectionStatus(idx)"
                    #rejectLabel
                  >
                    <input
                      type="checkbox"
                      class="d-none reject-check"
                      name="reject"
                      [value]="validatedMega?.status === 'reject'"
                      required
                      #rejectRadio
                    />
                    <i
                      class="fa fa-circle-o"
                      aria-hidden="true"
                      *ngIf="validatedMega?.status !== 'reject'"
                    ></i>
                    <i
                      class="fa fa-dot-circle-o"
                      aria-hidden="true"
                      *ngIf="validatedMega?.status === 'reject'"
                    ></i>
                    <label class="radio-buttons-labels">Reject</label>
                  </div>
                </td>
                <td class="td_cell">
                  <div class="row mega-cusip-row gx-0">
                    <div class="col-12 col-md-2 pl-0">
                      <label for="megaNumber" class="fs-13">Pool #: </label>
                      <span id="megaNumber" class="fs-15 fw-bold">{{
                        validatedMega?.megaNumber ? validatedMega?.megaNumber : ''
                      }}</span>
                    </div>
                    <div class="col-12 col-md-2 pl-0">
                      <label for="cusip" class="fs-13 pl-7">CUSIP: </label>
                      <span id="cusip" class="fs-15 fw-bold">{{
                        validatedMega?.cusip ? validatedMega?.cusip : ''
                      }}</span>
                    </div>
                    <div class="col-12 col-md-2 pl-0">
                      <label for="settlement" class="fs-13">Settlement: </label>
                      <span id="settlement" class="fs-15">{{
                        validatedMega?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </div>
                    <div class="col-12 col-md-3 pr-40">
                      <label for="coupon" class="fs-13">{{ megaType[idx] }}: </label>
                      <span id="coupon" class="fs-15">{{
                        validatedMega?.coupon | number: '1.3-3'
                      }}</span>
                    </div>
                    <div class="col-12 col-md-3 pl-0 pr-0 d-flex justify-content-end">
                      <span>
                        <label for="feeDollars" class="fs-13">Fee ($): </label>
                        <ng-container *ngIf="disclaimerCheck(validatedMega); else noDisclaimer">
                          {{ needsDisclaimer() }}
                          <span id="feeDollars" class="fs-15 fw-bold fee-warning-red"
                            >{{
                              validatedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                            }}*</span
                          >
                        </ng-container>
                        <ng-template #noDisclaimer>
                          <span id="feeDollars" class="fs-15 fw-bold">{{
                            validatedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                          }}</span>
                        </ng-template>
                      </span>
                    </div>
                  </div>
                  <div class="row gx-0">
                    <div class="col-12 col-md-4 pl-0 pr-0">
                      <label for="securityDescription" class="fs-13">Security Description: </label>
                      <span id="securityDescription" class="fs-15">{{
                        validatedMega?.megaDescription ? validatedMega?.megaDescription : ''
                      }}</span>
                    </div>
                    <div class="col-12 col-md-2 pl-0">
                      <label for="maturity" class="fs-13">Maturity: </label>
                      <span id="maturity" class="fs-15">{{
                        validatedMega?.maturityDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </div>
                    <div class="col-12 col-md-3 pr-40">
                      <label for="issueDate" class="fs-13">Issue: </label>
                      <span id="issueDate" class="fs-15">{{
                        validatedMega?.issueDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </div>
                    <div class="col-12 col-md-3 pl-0 pr-0 d-flex justify-content-end">
                      <span>
                        <label for="amountIssued" class="fs-13">Amount Issued: </label>
                        <span id="amountIssued" class="fs-15 fw-bold">{{
                          validatedMega?.issueAmount | currency: 'USD' : 'symbol' : '1.2-2'
                        }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="row gx-0">
                    <div class="col-12 col-md-4 pl-0 pr-0">
                      <label for="freddieParticipationAmount" class="fs-13"
                        >Freddie Participation Amount:
                      </label>
                      <span id="freddieParticipationAmount" class="fs-15">{{
                        validatedMega?.freddieIssuedAmt
                          ? (validatedMega?.freddieIssuedAmt | currency: 'USD' : 'symbol' : '1.2-2')
                          : '0.00'
                      }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <p class="fee-warning-red">{{ disclaimerMessage }}</p>
        </div>
      </form>
    </div>
    <div class="validation-pool-model-window" *ngIf="displayNavigateAwayPopup">
      <div class="panel panel-default fadeInUpBig">
        <div class="panel-body pool-info-cancel-confirmation-model">
          <h4>You are attempting to leave this page.</h4>
          <br />
          <p>
            By doing so, none of your pool information will be allocated and all of your work to
            this point will be lost.
          </p>
          <br />
          <h4>Do you wish to proceed?</h4>
          <br />
          <button class="button fm-tertiary-button" (click)="displayNavigateAwayPopup = false">
            NO
          </button>
          <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
            YES
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="warning-modal-window" *ngIf="showFreddieIssuedAmtWarning">
  <div class="panel panel-default fadeInUpBig">
    <div class="panel-body">
      <p [innerHTML]="freddieWarningMessage"><br /></p>
      <h4>Do you wish to proceed?</h4>
      <br />
      <button class="button fm-tertiary-button" (click)="cancelCommit()">NO</button>
      <button class="button fm-primary-button" (click)="continueToCommit(commitRequest)">
        YES
      </button>
    </div>
  </div>
</div>
